import React, { useState } from "react";

import { authClasses } from "../../../pages/Auth/authClasses";
import axios from "axios";

const PAYMENT_BASE_URL =
	"https://us-central1-sidewinder-3daf9.cloudfunctions.net/app";
const DASHBOARD_URL = "http://dashboard.sidewinderva.com/";

const productsByCost = {
	90: { product: "prod_PpwMfMnIwSujlM", unit_amount: 9300 },
	120: { product: "prod_Q9GV5nWeK3fDqP", unit_amount: 12389 },
	150: { product: "prod_URqagPa2QG5bCy", unit_amount: 15479 },
};

const getCardUnitAmount = (cost) => {
	const baseAmount = Math.round(Number(cost) * 100);
	if (!Number.isFinite(baseAmount) || baseAmount <= 0) {
		return null;
	}
	return Math.ceil((baseAmount + 30) / (1 - 0.029));
};

const getPriceData = (evnt, isTeamFee) => {
	const eventCost = String(evnt.cost);

	if (!isTeamFee && productsByCost[eventCost]) {
		return productsByCost[eventCost];
	}

	if (evnt.type === "Tryout") {
		return { product: "prod_PrUSSBd7SjrtWc", unit_amount: 2606 };
	}

	const unitAmount = isTeamFee
		? Math.round(Number(evnt.cost) * 100)
		: getCardUnitAmount(evnt.cost);
	if (Number.isFinite(unitAmount) && unitAmount > 0) {
		return {
			product_data: {
				name: `${evnt.title} ${
					isTeamFee ? "Team Registration Fee" : "Registration Fee"
				}`,
			},
			currency: "usd",
			unit_amount: unitAmount,
		};
	}

	return productsByCost[150];
};

const getRegistrationID = (athlete, evnt) =>
	evnt.teamPaymentRegistrationID ??
	athlete.registrations.find((registration) => registration.id === evnt.id)
		.regID;

const buildPaymentUrl = (evnt, regID, isTeamFee) => {
	const paymentPath = isTeamFee ? "payteamfee" : "payregistration";
	const params = new URLSearchParams({
		cancelUrl: DASHBOARD_URL,
		successUrl: DASHBOARD_URL,
		regID,
	});

	if (isTeamFee) {
		params.set("eventID", evnt.id);
		params.set("teamID", evnt.teamID ?? evnt.teamName);
		params.set("teamName", evnt.teamName);
	}

	return `${PAYMENT_BASE_URL}/${paymentPath}?${params.toString()}`;
};

const PayPopup = ({ athlete, evnt, setPayEvent }) => {
	const { buttonSmall } = authClasses;
	const isTeamFee = evnt.isTeamFee === true;

	const [loading, setLoading] = useState(false);
	const [paying, setPaying] = useState(false);
	const [error, setError] = useState(null);

	const handlePay = async () => {
		setLoading(true);

		const lineItems = [
			{
				data: {
					price_data: getPriceData(evnt, isTeamFee),
					quantity: 1,
				},
			},
		];

		try {
			const regID = getRegistrationID(athlete, evnt);
			const response = await axios.post(
				buildPaymentUrl(evnt, regID, isTeamFee),
				lineItems,
				{
					headers: {},
				},
			);
			if (!response.data?.url) {
				const stripeMessage =
					response.data?.error?.message ??
					"Payment session URL was not returned.";
				throw new Error(stripeMessage);
			}

			window.location.href = response.data.url;
			setLoading(false);
			setPaying(true);
			return response.data.url;
		} catch (error) {
			setError(error);
			setLoading(false);
			return [];
		}
	};

	return (
		<div className="fixed inset-0 z-20 flex items-center justify-center overflow-y-auto bg-black/75 px-4 py-6">
			<div className="grid max-h-[92vh] w-full max-w-2xl gap-5 overflow-y-auto rounded-lg border border-white/10 bg-[#24262c] p-5 shadow-2xl shadow-black/40">
				{error ? (
					<div className="grid gap-3">
						<h3 className="m-0 text-2xl text-white">Error Starting Payment</h3>
						<p className="m-0 text-sm text-slate-300">
							Email director@sidewinderva.com if this keeps happening.
						</p>
						<small className="rounded-md border border-red-300/30 bg-red-500/15 p-3 text-red-100">
							{error.toString()}
						</small>
						<button
							className={buttonSmall}
							onClick={() => {
								setError(null);
								setPayEvent(null);
							}}
						>
							Ok
						</button>
					</div>
				) : paying ? (
					<div className="grid gap-3">
						<h3 className="m-0 text-2xl text-white">Payment Started</h3>
						<p className="m-0 text-sm text-slate-300">
							Stripe will send you back here after checkout. It can take a
							minute for payment status to update after you return.
						</p>
						<button
							className={buttonSmall}
							onClick={() => {
								setError(null);
								setPayEvent(null);
								setPaying(false);
								setLoading(false);
							}}
						>
							Ok
						</button>
					</div>
				) : (
					<div className="grid gap-5">
						<div className="grid gap-2 border-b border-white/10 pb-4">
							<span className="text-xs font-bold uppercase tracking-[0.18em] text-accent-color-2">
								Payment
							</span>
							<h3 className="m-0 text-2xl text-white">
								{isTeamFee
									? "Pay Team Registration Fee"
									: `Pay ${evnt.type === "Tryout" ? "Tryout" : "Event"} Fee`}
							</h3>
							<div className="w-fit rounded-full border border-accent-color-2/30 bg-[rgba(108,207,246,0.12)] px-3 py-1 text-sm font-bold text-accent-color-2">
								${evnt.cost} {isTeamFee ? "team fee" : ""}
							</div>
						</div>

						<div className="grid gap-2 rounded-md border border-white/10 bg-black/20 p-4 text-sm text-slate-300">
							{isTeamFee ? (
								<p className="m-0">
									Team: <strong className="text-white">{evnt.teamName}</strong>
								</p>
							) : (
								<p className="m-0">
									Athlete:{" "}
									<strong className="text-white">
										{athlete.firstName} {athlete.lastName}
									</strong>
								</p>
							)}
							<p className="m-0">
								Event:{" "}
								<strong className="text-white">
									{evnt.title} - {evnt.dateString}
								</strong>
							</p>
						</div>

						<div className="grid gap-4 text-sm text-slate-300">
							<div className="grid gap-1">
								<h4 className="m-0 text-base font-bold text-white">
									Pay by Card
								</h4>
								<p className="m-0">
									Use the button below to pay securely by card. A small card fee
									is added at checkout.
									{isTeamFee
										? " This pays the team registration fee for the whole team. Payment status may take a minute to update after Stripe sends you back here."
										: ""}
								</p>
							</div>

							<div className="grid gap-1 border-t border-white/10 pt-4">
								<h4 className="m-0 text-sm font-bold text-slate-300">
									Pay with Zelle (No card fee)
								</h4>
								<p className="m-0 text-slate-400">
									Send payment to director@SidewinderVA.com and include the
									{isTeamFee
										? " team name and league in the description."
										: " athlete's name and the event in the description."}
								</p>
								<p className="m-0 text-xs text-slate-500">
									Zelle payments are marked paid manually by an admin, so they
									may not show immediately.
								</p>
							</div>
						</div>

						<div className="flex flex-wrap justify-end gap-3 border-t border-white/10 pt-4">
							<button
								className={`${buttonSmall} border-white/10 bg-[#333333] hover:bg-[#3f3f3f]`}
								disabled={loading}
								onClick={() => setPayEvent(null)}
							>
								Cancel
							</button>
							<button
								className={buttonSmall}
								onClick={() => handlePay()}
								disabled={loading}
							>
								{loading ? "Loading..." : "Pay by Card"}
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PayPopup;
